import { useDimension } from "./contexts/DimensionalContext"
import { Canvas, useThree } from '@react-three/fiber'
import Experience from './Experience.jsx'
import { Analytics } from "@vercel/analytics/react"
import Portfolio2D from "./components2D/Portfolio2D"
import { useState, useEffect, useRef } from 'react'
import gsap from 'gsap'

const DimensionSwitch = () => {
    const { portfolioDimension, isTransitioning, setIsTransitioning } = useDimension();
    const [currentView, setCurrentView] = useState(portfolioDimension);
    const [opacity, setOpacity] = useState(1);
    
    useEffect(() => {
        if (portfolioDimension !== currentView) {
            setIsTransitioning(true);
            
            gsap.to({ value: 1 }, {
                value: 0,
                duration: 0.6,
                ease: "power2.inOut",
                onUpdate: function() {
                    setOpacity(this.targets()[0].value);
                },
                onComplete: () => {
                    setCurrentView(portfolioDimension);
                    
                    gsap.to({ value: 0 }, {
                        value: 1,
                        duration: 0.6,
                        ease: "power2.inOut",
                        onUpdate: function() {
                            setOpacity(this.targets()[0].value);
                        },
                        onComplete: () => {
                            setIsTransitioning(false);
                        }
                    });
                }
            });
        }
    }, [portfolioDimension, currentView, setIsTransitioning]);
    
    return (
        <div style={{ width: '100vw', height: '100vh', position: 'relative', overflow: 'hidden' }}>
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'radial-gradient(circle, rgba(10,0,30,0.95) 0%, rgba(0,0,0,1) 100%)',
                opacity: 1 - opacity,
                pointerEvents: 'none',
                zIndex: 999,
                transition: 'opacity 0.3s ease'
            }} />
            
            <div style={{ opacity: opacity, width: '100%', height: '100%', transition: 'opacity 0.3s ease' }}>
                {currentView ? (
                    <Canvas
                        shadows
                        gl={{ antialias: true, powerPreference: "default"}}
                        dpr={[1, 2]}
                        camera={{
                            fov: 75,
                            near: 0.6,
                            far: 105,
                            position: [ 100.5, 156, 6 ]
                        }}
                    >
                        <TransitionHandler isTransitioning={isTransitioning} />
                        <Experience />
                        <Analytics />
                    </Canvas>
                ) : (
                    <Portfolio2D />
                )}
            </div>
        </div>
    )
}

function TransitionHandler({ isTransitioning }) {
    const { camera } = useThree();
    const initialPosition = useRef({ x: 100.5, y: 156, z: 6 });
    
    useEffect(() => {
        if (!camera) return;

        if (isTransitioning) {
            gsap.to(camera.position, {
                duration: 1.2,
                y: camera.position.y + 50,
                z: camera.position.z + 30,
                ease: "power2.inOut"
            });
            
            gsap.to(camera.rotation, {
                duration: 1.2,
                x: camera.rotation.x - 0.3,
                ease: "power2.inOut"
            });
            
            gsap.to(camera, {
                duration: 1.2,
                fov: 90,
                ease: "power2.inOut",
                onUpdate: () => {
                    camera.updateProjectionMatrix();
                }
            });
        } else {
            gsap.to(camera.position, {
                duration: 1.2,
                x: initialPosition.current.x,
                y: initialPosition.current.y,
                z: initialPosition.current.z,
                ease: "power2.out"
            });
            
            gsap.to(camera.rotation, {
                duration: 1.2,
                x: 0,
                ease: "power2.out"
            });
            
            gsap.to(camera, {
                duration: 1.2,
                fov: 75,
                ease: "power2.out",
                onUpdate: () => {
                    camera.updateProjectionMatrix();
                }
            });
        }
    }, [isTransitioning, camera]);
    
    return null;
}

export default DimensionSwitch;